(function ($) {

	function set_active() {
		if ($(this).val() !== "") {
			$(this).closest(".form__input").addClass('active')
		} else {
			$(this).closest(".form__input").removeClass('active')
		}
	}

	function init_active_fields(){
		$("input, select, textarea").each(set_active)
		$("input, select, textarea").on("change", set_active)
	}

	init_active_fields()
	$(document).on("gp_ajax_done", init_active_fields)

})(jQuery)